export default __webpack_public_path__ + "static/media/contact.28dbfa22.jpg";